"use strict";

exports.__esModule = true;

exports.default = function (obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/interopRequireDefault.js
 ** module id = 473
 ** module chunks = 0
 **/